import React from 'react'
import { localsMessages } from '../utility/getTemplateData'
import { StyleSheet, css } from 'aphrodite';
import colors from '../styles/colors';
import fonts from '../styles/fonts';
import _get from 'lodash/get';

let messages = localsMessages('common/orLine')

const styles = StyleSheet.create({
	orLineContainer: {
		position: 'relative',
		width: '100%',
		textAlign: 'center',
		zIndex: 1
	},
	line: {
		position: 'relative',
		zIndex: 2,
		top: 11,
		width: '100%',
		borderBottom: `1px solid ${colors.lightestGray}`
	},
	text: {
		display: 'inline-block',
		paddingLeft: 8,
		paddingRight: 8,
		zIndex: 3,
		position: 'relative',
		background: 'white',
		fontFamily: fonts.ppSansBigRegular
	}
});

class OrLineComponent extends React.Component {

	render () {
		let orLabel = _get(messages, 'label.or', '');

		return (
			<div className={`${css(styles.orLineContainer)}`}>
				<div className={`${css(styles.line)}`}></div>
				<div className={`${css(styles.text)}`}>{orLabel}</div>
			</div>
		);
	}
}

export default OrLineComponent



// WEBPACK FOOTER //
// ./components/orLine.js